export const data = {
    labels: [''],
    datasets: [
        {
            label: 'Regionaler Durchschnitt (Soll)',
            data: [0],
            backgroundColor: "rgba(251, 191, 36, 0.7)",
        },
        {
            label: 'Mein Durchschnitt (Ist)',
            data: [0],
            // Dynamic per-bar color set from container based on Soll comparison
        }
    ]
};